module.exports = __webpack_public_path__ + "static/media/screenshot-7.748df62f.png";